import { RefObject, useEffect, useCallback } from 'react';

type EventType = 'click' | 'mousedown' | 'mouseup' | 'touchstart' | 'touchend' | 'focusin' | 'focusout';

export function useOutsideClick<Element extends HTMLElement>(ref: RefObject<Element>, handler: () => void, eventType?: EventType): void;
export function useOutsideClick<Element extends HTMLElement>(refs: RefObject<Element>[], handler: () => void, eventType?: EventType): void;
export function useOutsideClick<Element extends HTMLElement>(
  refOrRefs: RefObject<Element> | RefObject<Element>[],
  handler: () => void,
  eventType: EventType = 'mousedown',
) {
  const refs = Array.isArray(refOrRefs) ? refOrRefs : [refOrRefs];

  const handleClickOutside = useCallback(
    (event: Event) => {
      const target = event.target as Node;
      const isInside = refs.some((ref) => ref.current?.contains(target));
      if (!isInside) handler();
    },
    [refs, handler],
  );

  useEffect(() => {
    document.addEventListener(eventType, handleClickOutside);
    return () => {
      document.removeEventListener(eventType, handleClickOutside);
    };
  }, [eventType, handleClickOutside]);
}
